export type FontMetadata = number[];

export enum TextSource {
  INTERNAL,
  COPY,
  HISTORY,
  INITIAL,
}

export type FontData = [text: string, metadata: FontMetadata, textSource: TextSource];

export type EditHistoryData<T> = {
  next: T[];
  prev: T[];
};

export type EditHistoryStore<T> = EditHistoryData<T> & {
  add: (item: T) => void;
  redo: () => T;
  undo: () => T;
  getAll: () => EditHistoryData<T>;
  setAll: ({ prev, next }: EditHistoryData<T>) => void;
};

export type InterappData = {
  fontData: FontData;
  editorExpanded: boolean;
  history: EditHistoryData<FontData>;
};
